import { SVGProps } from "react";

export function InnoveraGlyph(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "scaleX(-1)" }}
      {...props}
    >
      <path
        d="M12.7534 2.62803H11.897L2.78817 20.6864H12.9171L12.4462 19.6136L4.59932 19.636L6.66026 15.5576H6.66287L7.94486 13.0336L12.3261 4.32962L16.7073 13.0336L17.9893 15.5576H17.992L20.5829 20.6872H21.8641L12.7534 2.62803Z"
        fill="currentColor"
      />
      <path
        d="M22.2522 20.9136H20.4254L12.327 4.8712L4.98836 19.4072L12.6133 19.3856L13.2835 20.9144H2.4L11.7395 2.4H12.9118L12.978 2.532L22.2522 20.9136ZM20.7413 20.4584H21.4767L12.5959 2.8552H12.0554L3.17633 20.4584H12.5507L12.28 19.8408L4.21115 19.864L7.72119 12.9368L12.327 3.7872L20.7422 20.4584H20.7413Z"
        fill="currentColor"
      />
    </svg>
  );
}
